import embla from 'embla-carousel';

class ProductsNav {
  header = document.querySelector('.header');
  productsTerms = document.querySelector('.products-terms');
  scroll = Math.abs(window.scrollY);

  constructor() {
    const sections = document.querySelectorAll('.products-nav');

    sections.forEach(section => {
      const root = section.querySelector('.products-nav__slider');
      const items = root.querySelectorAll('.products-nav__item');
      
      const options = {
        dragFree: true,
        watchDrag: items.length > 1 ? true : false,
      };

      embla(root, options);

      section.style.setProperty('--top', this.header.getBoundingClientRect().height + 'px');

      window.addEventListener('resize', () => {
        section.style.setProperty('--top', this.header.getBoundingClientRect().height + 'px');
      });

      const handleScroll = () => {
        if (window.scrollY > this.scroll) {
          section.classList.add('hidden');
        } else {
          if (window.scrollY < this.productsTerms.offsetTop) {
            section.classList.add('hidden');
          }
          else {
            section.classList.remove('hidden');
          }
        }
    
        this.scroll = Math.abs(window.scrollY);
      }

      handleScroll();
      window.addEventListener('scroll', () => handleScroll());
    });
  }
}

export default ProductsNav;
